<ngx-spinner bdColor="rgba(36,34,36,0.8)" size="custom" style="width: 80px; height: 80px;" color="#81c784" type="timer">
  <p style="font-size: 20px; color: white; z-index: 9999999;">Getting remote collections...</p>
</ngx-spinner>

<ng-container *ngIf="error">
  <p-message severity="error" text="{{ error }}"></p-message>
  <br/>
  <p-messages severity="warn">
    <ng-template pTemplate>
      <i class="pi pi-info-circle"></i>
      <div class="p-ml-2">
        Into the <strong>worker</strong> directory, you must to have a directory called <strong>certs</strong> with the <strong>global-bundle.pem</strong> certificate (<strong>/worker/certs/global-bundle.pem</strong>).
        And don't forget <strong>ON the VPN</strong>.
      </div>
    </ng-template>
  </p-messages>
  <br/>
  <p-button label="Retry" icon="pi pi-refresh" class="p-button-primary" (click)="loader()"></p-button>
</ng-container>

<ng-container *ngIf="sourceCollections">
  <p-messages severity="info">
    <ng-template pTemplate>
      <i class="pi pi-info-circle"></i>
      <div class="p-ml-2">
        This sync is just available in the local environment. You can check the sync in this <a href="http://localhost:3000/api/admin/queues/queue/builder" target="_blank">Queue</a>.
      </div>
    </ng-template>
  </p-messages>
  <br/>
  <ng-container *ngIf="inProgressMessage">
    <p-messages severity="warn">
      <ng-template pTemplate>
        <i class="pi pi-info-circle"></i>
        <div class="p-ml-2">
          {{ inProgressMessage }}. If for some reason the sync could not be completed, probably the <strong>builderSyncInProgress</strong> attribute in the <strong>cmssettings</strong> collection is still <strong>true</strong>. You can try to change it to <strong>false</strong> and try again.
        </div>
      </ng-template>
    </p-messages>
  </ng-container>
  <br/><br/>
  <p-button label="Sync to Local" icon="pi pi-refresh" class="p-button-primary" (click)="syncToLocal()"></p-button>
  <br/><br/>
  <p-pickList
    [source]="sourceCollections" 
    [target]="targetCollections"
    sourceHeader="Available to sync" 
    targetHeader="To proccess in the sync"
    [dragdrop]="true" 
    [showSourceControls]="false"
    [showTargetControls]="false"
    sourceFilterPlaceholder="Search by name"
    targetFilterPlaceholder="Search by name"
    [responsive]="true"
    filterBy="name"
    [sourceStyle]="{ height: '30rem' }"
    [targetStyle]="{ height: '30rem' }"
  >
    <ng-template let-item pTemplate="item">
      <div>{{ item.name }}</div>
    </ng-template>
  </p-pickList>
</ng-container>

<p-toast></p-toast>
